<template>
    <div>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <span class="page-title">系统设置</span>
            </el-breadcrumb-item>
            <el-breadcrumb-item>快讯编辑</el-breadcrumb-item>
        </el-breadcrumb>
        <br><br>
        <el-input :value="newsDetail.title" @change="handleFormChange('title', $event)" placeholder="快讯标题"></el-input>
        <br><br>
        <el-ueditor :value="newsDetail.content" @change="handleFormChangeContent"></el-ueditor>
        <br>
        <el-select :value="newsDetail.hot" placeholder="请选择" @change="handleFormChange('hot', $event)">
            <el-option v-for="item in newsHotList"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
        </el-select>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <el-button @click="goBack()">取消</el-button>
      <el-button type="primary" @click="handleSave()">保存</el-button>
    </div>
</template>

<script>
    import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';
    import elUeditor from '../../../../components/elUeditor';
    export default {
        name: "NewsEditor",
        components: {elUeditor},
        computed: {
            ...mapState('newsSetting', ['newsHotList','opType','query']),
            ...mapGetters('newsSetting', ['newsDetail'])
        },
        methods:{
            ...mapActions('newsSetting', ['update','create','setDetail']),
            ...mapMutations('newsSetting', ['setNewsDetail']),
            goBack() {
                this.setDetail({hot:false});
                this.$router.push({path:'/home/setting/news'});
            },
            handleFormChangeContent(val) {
                this.handleFormChange('content',val)
            },
            handleFormChange(type, value) {
                this.setNewsDetail({
                    ...this.newsDetail,
                    [type]: value
                });
            },
            handleSave(){
                if (this.newsDetail.title === null || this.newsDetail.title === '') {
                    this.$message.error('标题不能为空');
                    return;
                }
                if (this.opType === 'update') {
                    this.update(this.newsDetail).then(() => {
                        this.$message.success('修改成功！');
                        this.goBack();
                    });
                }
                if (this.opType === 'insert') {
                    this.create({...this.query, ...this.newsDetail}).then(() => {
                        this.$message.success('更新成功！');
                        this.goBack();
                    })
                }

            }
        }
    }
</script>

<style scoped>

</style>